import { render, staticRenderFns } from "./IngredientDialog.vue?vue&type=template&id=53c457c9&scoped=true&"
import script from "./IngredientDialog.vue?vue&type=script&lang=js&"
export * from "./IngredientDialog.vue?vue&type=script&lang=js&"
import style0 from "./IngredientDialog.vue?vue&type=style&index=0&lang=css&"
import style1 from "./IngredientDialog.vue?vue&type=style&index=1&id=53c457c9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c457c9",
  null
  
)

export default component.exports